import PropTypes from 'prop-types';
import Chart, { useChart } from '../chart';
import { metaFor } from './measurementMeta';
import { displayTemperature } from '../../utils/temperature';

export default function ReadingsChart({ readings, measurement, useFahrenheit = false }) {
  const meta = metaFor(measurement, useFahrenheit);
  const data = (readings || [])
    .filter((r) => r[measurement] !== undefined && r[measurement] !== null)
    // Telemetry is stored in Celsius; the conversion is a display step, so the
    // axis unit above and the points here move together.
    .map((r) => [r.t, measurement === 'temp' ? displayTemperature(r[measurement], useFahrenheit) : r[measurement]]);

  const options = useChart({
    chart: { id: 'readings' },
    xaxis: { type: 'datetime' },
    yaxis: { title: { text: meta.unit } },
    stroke: { width: 2, curve: 'smooth' },
    tooltip: { x: { format: 'HH:mm' } },
    legend: { show: false },
  });

  const series = [{ name: meta.label, data }];

  return <Chart type="line" series={series} options={options} height={320} />;
}

ReadingsChart.propTypes = {
  readings: PropTypes.array,
  measurement: PropTypes.string.isRequired,
  useFahrenheit: PropTypes.bool,
};
